import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const u = await authSession(session_id);
        setUser(u);
        // restore search params (e.g., ?save=audit_xyz) before navigating
        const search = window.location.search || "";
        navigate(`/app${search}`, { replace: true, state: { user: u } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="section-pad py-32">
      <div className="overline">Signing you in…</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter mt-3">One moment.</h1>
    </div>
  );
}
